var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloseBanner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.295554 13.7101C0.484116 13.8972 0.739383 14.0015 1.00497 14C1.27199 13.9989 1.52746 13.8909 1.71438 13.7001L6.99459 8.41772L12.2846 13.71C12.4732 13.8971 12.7285 14.0014 12.9941 13.9998C13.2596 14.0014 13.5149 13.8971 13.7035 13.71C13.8926 13.5223 13.999 13.2668 13.999 13.0003C13.999 12.7337 13.8926 12.4782 13.7035 12.2906L8.41341 6.99831L13.7044 1.70509C14.0918 1.31521 14.0918 0.685551 13.7044 0.295676C13.5168 0.106441 13.2615 0 12.995 0C12.7286 0 12.4732 0.106441 12.2856 0.295676L6.99958 5.5839L1.7134 0.295538C1.32161 -0.0964216 0.686377 -0.0964216 0.294579 0.295538C-0.0972184 0.687497 -0.0972184 1.32299 0.294579 1.71495L5.58076 7.00331L0.295554 12.2907C0.106398 12.4784 0 12.7339 0 13.0004C0 13.2669 0.106398 13.5224 0.295554 13.7101Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseBanner);
export default __webpack_public_path__ + "static/media/ic_close_banner.4815fe9d0cb9249d8f5839e55b2de63f.svg";
export { ForwardRef as ReactComponent };